'use client';

import type { ComponentPropsWithoutRef, Ref } from 'react';

import classnames from 'classnames';

import type { BaseComponentProps } from '../../base-component.types';
import type { MultipleChoiceQuestionType } from '../multiple-choice-question/MultipleChoiceQuestion.types';
import { Option } from './Option';
import { QuestionStatement } from './QuestionStatement';

import styles from './Question.module.scss';

type QuestionProps = ComponentPropsWithoutRef<'div'> &
  BaseComponentProps & {
    question: MultipleChoiceQuestionType;
    readOnly?: boolean;
    onResponse: (answer: number) => void;
  };

/** A question as it is asked: what it says, and the choices to answer it with. */
export function Question({
  style,
  className,
  question,
  readOnly = false,
  onResponse,
  ref,
  ...rest
}: QuestionProps & { ref?: Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      style={style}
      className={classnames(styles['main'], className)}
      {...rest}
    >
      <QuestionStatement question={question} />
      <div
        className={classnames(
          styles['options'],
          readOnly && styles['options--readonly'],
        )}
      >
        {question.options.map((option, index) => (
          <Option
            key={index}
            id={index + 1}
            text={option}
            appearance={readOnly ? 'paper' : 'card'}
            state={
              index + 1 === question.selectedOptionIndex ? 'selected' : 'none'
            }
            onSelect={readOnly ? undefined : onResponse}
          />
        ))}
      </div>
    </div>
  );
}
